import {NgModule} from '@angular/core';
import {MatTableModule} from '@angular/material/table';
import {MatDialogModule} from '@angular/material/dialog';
import {DoughnutModule} from '../doughnut/doughnut.module';
import {MatPaginatorModule} from '@angular/material/paginator';
import {PortfolioDetailComponent} from './portfolio-detail.component';
import {InvestormenuModule} from '../investormenu/investormenu.module';
import {ConfirmPopUpModule} from '../comfirm-pop-up/confirm-pop-up.module';
import {CommonSectionsModule} from '../views/common/common-sections.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {PortfolioDetailRoutingModule} from './portfolio-detail-routing.module';
import {SelectedPreferencesModule} from '../portfolio-creation/selected-preferences/selected-preferences.module';
import {PortfolioPreferencesPickerModule} from '../portfolio-preferences-picker/portfolio-preferences-picker.module';
import {IndianCurrencyFormatterModule} from '../views/common/indian-currency-formatter/indian-currency-formatter.module';
import {PortfolioDetailPreferencesComponent} from './portfolio-detail-preferences/portfolio-detail-preferences.component';
import {PortfolioPreferencesConfirmationPopUpComponent} from './portfolio-detail-preferences/pop-up/portfolio-preferences-confirmation-pop-up.component';

@NgModule({
    declarations: [PortfolioDetailComponent, PortfolioDetailPreferencesComponent, PortfolioPreferencesConfirmationPopUpComponent],
    imports: [PortfolioDetailRoutingModule, CommonSectionsModule, InvestormenuModule, MatTableModule, DoughnutModule,
        SelectedPreferencesModule, MatPaginatorModule, PortfolioPreferencesPickerModule, IndianCurrencyFormatterModule,
        MatProgressSpinnerModule, MatDialogModule, ConfirmPopUpModule],
    entryComponents: [PortfolioPreferencesConfirmationPopUpComponent]
})
export class PortfolioDetailModule {
}